import React, { Component } from "react";
import axios from "axios";
import { Card, Grid, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import { Navigate } from "react-router-dom";
import { MultiSelect } from "react-multi-select-component";
import Constants from "Helpers/Constants";
import init from "Helpers/WindowToken";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import MDSnackbar from "components/MDSnackbar";

export default class UpdateScheduledTestSeries extends Component {
  state = {
    id: "",
    allSubjects: [],
    alltopics: [],
    selectedSubjects: [],
    selectedTopics: [],
    test_series_name: "",
    seats: 0,
    payment_type: "free",
    price: "",
    offer_price: "",
    test_start_time: "",
    test_end_time: "",
    negative_marking: "no",
    negative_marking_value: "",
    status: "inactive",
    show_full_image_in_app: "false",
    small_poster: null,
    large_poster: null,
    loading: false,
    notification: false,
    message: "",
    redirect: false,
  };

  componentDidMount() {
    const id = window.location.pathname.split("/")[2];
    this.setState({ id }, async () => {
      await this.getAllSubjects();
      await this.getTestSeriesDetails();
    });
  }

  getAllSubjects = async () => {
    if (init() === "success") {
      const resp = await axios.get(`${Constants.getUrls.getAllSubjects}?search=&limit=150`);
      const allSubjects = (resp?.data?.data?.docs || []).map((item) => ({
        label: item.subject_name,
        value: item._id,
      }));
      this.setState({ allSubjects });
    }
  };

  handleTopic = async (subjectIds) => {
    if (init() === "success") {
      const resp = await axios.get(`${Constants.getUrls.getAllTopics}?subject_id=${subjectIds}`);
      const alltopics = (resp?.data?.data?.docs || []).map((item) => ({
        label: item.topic_name,
        value: item._id,
      }));
      this.setState({ alltopics });
    }
  };

  getTestSeriesDetails = async () => {
    try {
      const resp = await axios.get(`${Constants.getUrls.getSingleTestSeries}${this.state.id}`);
      const data = resp?.data?.data || {};
      const selectedSubjects = (data.subject_id || []).map((item) => ({
        label: item.subject_name,
        value: item._id,
      }));
      const selectedTopics = (data.topic_id || []).map((item) => ({
        label: item.topic_name,
        value: item._id,
      }));

      await this.handleTopic(selectedSubjects.map((item) => item.value));

      this.setState({
        test_series_name: data.test_series_name || "",
        selectedSubjects,
        selectedTopics,
        seats: data.seats || 0,
        payment_type: data.payment_type || "free",
        price: data.price || "",
        offer_price: data.offer_price || "",
        test_start_time: data.test_start_time
          ? new Date(data.test_start_time).toISOString().slice(0, 16)
          : "",
        test_end_time: data.test_end_time
          ? new Date(data.test_end_time).toISOString().slice(0, 16)
          : "",
        negative_marking: data.negative_marking || "no",
        negative_marking_value: data.negative_marking_value || "",
        status: data.status || "inactive",
        show_full_image_in_app: data.show_full_image_in_app === true ? "true" : "false",
      });
    } catch (err) {
      this.setState({
        notification: true,
        message: err?.response?.data?.message || "Failed to load scheduled test series.",
      });
    }
  };

  handleInput = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleFile = (e) => {
    this.setState({ [e.target.name]: e.target.files[0] });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const fd = new FormData();
    fd.append("test_series_name", this.state.test_series_name);
    fd.append("payment_type", this.state.payment_type);
    fd.append("price", this.state.price || 0);
    fd.append("offer_price", this.state.offer_price || 0);
    fd.append("subject_id", JSON.stringify(this.state.selectedSubjects.map((item) => item.value)));
    fd.append("topic_id", JSON.stringify(this.state.selectedTopics.map((item) => item.value)));
    fd.append("seats", this.state.seats || 0);
    fd.append("test_start_time", this.state.test_start_time + ":00.000Z");
    fd.append("test_end_time", this.state.test_end_time + ":00.000Z");
    fd.append("negative_marking", this.state.negative_marking);
    fd.append("negative_marking_value", this.state.negative_marking_value || 0);
    fd.append("status", this.state.status);
    fd.append("show_full_image_in_app", this.state.show_full_image_in_app);
    if (this.state.small_poster) {
      fd.append("small_poster", this.state.small_poster);
    }
    if (this.state.large_poster) {
      fd.append("large_poster", this.state.large_poster);
    }

    this.setState({ loading: true });

    try {
      const resp = await axios.put(`${Constants.putUrls.updateTestSeries}${this.state.id}`, fd);
      this.setState({
        loading: false,
        notification: true,
        message: resp.data.message,
      });
      setTimeout(() => {
        this.setState({ redirect: true });
      }, 1500);
    } catch (err) {
      this.setState({
        loading: false,
        notification: true,
        message: err?.response?.data?.message || "Failed to update scheduled test series.",
      });
    }
  };

  render() {
    if (this.state.redirect) {
      return <Navigate to="/testseries" />;
    }

    return (
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox pt={6} pb={3}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
            >
              <MDTypography variant="h6" color="white">
                Edit Scheduled Test Series
              </MDTypography>
            </MDBox>

            <MDBox py={3} px={2}>
              <form onSubmit={this.handleSubmit}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <InputLabel>Select Subject</InputLabel>
                    <MultiSelect
                      options={this.state.allSubjects}
                      value={this.state.selectedSubjects}
                      onChange={(selectedSubjects) => {
                        this.setState({ selectedSubjects }, () => {
                          this.handleTopic(selectedSubjects.map((item) => item.value));
                        });
                      }}
                      labelledBy="Select Subjects"
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <InputLabel>Select Topic</InputLabel>
                    <MultiSelect
                      options={this.state.alltopics}
                      value={this.state.selectedTopics}
                      onChange={(selectedTopics) => this.setState({ selectedTopics })}
                      labelledBy="Select Topics"
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <InputLabel>Test Series Name</InputLabel>
                    <TextField
                      name="test_series_name"
                      value={this.state.test_series_name}
                      onChange={this.handleInput}
                      style={{ width: "100%" }}
                      required
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <InputLabel>Payment Type</InputLabel>
                    <Select
                      name="payment_type"
                      value={this.state.payment_type}
                      onChange={this.handleInput}
                      style={{ width: "100%", height: "45px", color: "#111" }}
                    >
                      <MenuItem value="free">Free</MenuItem>
                      <MenuItem value="paid">Paid</MenuItem>
                    </Select>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <InputLabel>Seats</InputLabel>
                    <TextField
                      type="number"
                      name="seats"
                      value={this.state.seats}
                      onChange={this.handleInput}
                      style={{ width: "100%" }}
                      required
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <InputLabel>Negative Marking</InputLabel>
                    <Select
                      name="negative_marking"
                      value={this.state.negative_marking}
                      onChange={this.handleInput}
                      style={{ width: "100%", height: "45px", color: "#111" }}
                    >
                      <MenuItem value="yes">Yes</MenuItem>
                      <MenuItem value="no">No</MenuItem>
                    </Select>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <InputLabel>Price</InputLabel>
                    <TextField
                      type="number"
                      name="price"
                      value={this.state.price}
                      onChange={this.handleInput}
                      style={{ width: "100%" }}
                      required
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <InputLabel>Offer Price</InputLabel>
                    <TextField
                      type="number"
                      name="offer_price"
                      value={this.state.offer_price}
                      onChange={this.handleInput}
                      style={{ width: "100%" }}
                      required
                    />
                  </Grid>
                  {this.state.negative_marking === "yes" && (
                    <Grid item xs={12} md={3}>
                      <InputLabel>Deduct Marks</InputLabel>
                      <TextField
                        type="number"
                        name="negative_marking_value"
                        value={this.state.negative_marking_value}
                        onChange={this.handleInput}
                        style={{ width: "100%" }}
                        required
                      />
                    </Grid>
                  )}
                  <Grid item xs={12} md={3}>
                    <InputLabel>Status</InputLabel>
                    <Select
                      name="status"
                      value={this.state.status}
                      onChange={this.handleInput}
                      style={{ width: "100%", height: "45px", color: "#111" }}
                    >
                      <MenuItem value="active">Active</MenuItem>
                      <MenuItem value="inactive">Inactive</MenuItem>
                    </Select>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <InputLabel>App Card Layout</InputLabel>
                    <Select
                      name="show_full_image_in_app"
                      value={this.state.show_full_image_in_app}
                      onChange={this.handleInput}
                      style={{ width: "100%", height: "45px", color: "#111" }}
                    >
                      <MenuItem value="false">Standard Card</MenuItem>
                      <MenuItem value="true">Full Image Card</MenuItem>
                    </Select>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <InputLabel>Test Start Time</InputLabel>
                    <TextField
                      type="datetime-local"
                      name="test_start_time"
                      value={this.state.test_start_time}
                      onChange={this.handleInput}
                      style={{ width: "100%" }}
                      required
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <InputLabel>Test End Time</InputLabel>
                    <TextField
                      type="datetime-local"
                      name="test_end_time"
                      value={this.state.test_end_time}
                      inputProps={{ min: this.state.test_start_time }}
                      onChange={this.handleInput}
                      style={{ width: "100%" }}
                      required
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <InputLabel>Replace Small Poster</InputLabel>
                    <TextField
                      type="file"
                      name="small_poster"
                      onChange={this.handleFile}
                      inputProps={{ accept: "image/*" }}
                      style={{ width: "100%" }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <InputLabel>Replace Large Poster</InputLabel>
                    <TextField
                      type="file"
                      name="large_poster"
                      onChange={this.handleFile}
                      inputProps={{ accept: "image/*" }}
                      style={{ width: "100%" }}
                    />
                  </Grid>
                </Grid>

                <Grid align="left" mt={2}>
                  <MDButton variant="contained" size="small" color="info" type="submit">
                    {this.state.loading ? "Updating..." : "Update Scheduled Test Series"}
                  </MDButton>
                </Grid>
              </form>
            </MDBox>

            <MDSnackbar
              color="success"
              icon="notifications"
              title="AgriQuiz"
              content={this.state.message}
              dateTime="Just now"
              open={this.state.notification}
            />
          </Card>
        </MDBox>
      </DashboardLayout>
    );
  }
}
